import React, { Fragment, useContext } from "react";
import { Grid, Typography, Breadcrumbs, Link } from "@material-ui/core";
// import { makeStyles } from "@material-ui/core/styles";

// Contexts
import FacebookProfilesDashboardContext from "../../../context/facebook_profiles/dashboard/DashboardContext";

// Components
import DashboardActions from "./DashboardActions";
import DashboardDisplay from "./DashboardDisplay";

// const useStyles = makeStyles((theme) => ({}));

const Dashboard = () => {
  // const classes = useStyles();

  const { profiles, selected_profile } = useContext(
    FacebookProfilesDashboardContext
  );

  return (
    <Fragment>
      <Grid container spacing={0} justifyContent="flex-start">
        <Grid item xs={12}>
          <Typography variant="h4"> Facebook Profile </Typography>
        </Grid>
        <Grid item xs={12}>          
          {selected_profile ? (
            // With Selected Profile
            <Breadcrumbs aria-label="breadcrumb">
              <Link color="inherit" href="/facebook/profile">
                Profile
              </Link>
              <Link
                color="inherit"
                href={`/facebook/profile/${selected_profile.profile_id}`}
              >
                {selected_profile.profile_id}
              </Link>
            </Breadcrumbs>
          ) : (
            // Without Selected Profile
            <Breadcrumbs aria-label="breadcrumb">
              <Link color="inherit"> Profile </Link>
            </Breadcrumbs>
          )}
        </Grid>
      </Grid>
      {profiles && (
        <Fragment>
          <DashboardActions />
          <DashboardDisplay />
        </Fragment>
      )}
    </Fragment>
  );
};

export default Dashboard;
